import { render, staticRenderFns } from "./DestinationCountry.vue?vue&type=template&id=f642e792&scoped=true&"
import script from "./DestinationCountry.vue?vue&type=script&lang=js&"
export * from "./DestinationCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f642e792",
  null
  
)

export default component.exports